"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHost(url) {
    const split = url.split("/");
    return split[2];
}
exports.default = getHost;
